import { track } from '../utils/tracking';

document.addEventListener('DOMContentLoaded', () => {
  // Setup elements
  const dialog = document.getElementById('quizDialog');
  const openBtn = document.querySelectorAll('a[href="#quiz"]');
  const closeBtn = document.getElementById('closeQuizBtn');
  const quiz = dialog.querySelector('plan-quiz');

  // Open quiz handler
  const openQuiz = () => {
    dialog.classList.remove('animate-dialog-open');

    track('quiz_open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // Fallback for browsers that do not support dialog.showModal()
      dialog.style.display = 'block';
    }

    // Animate the dialog after it's opened
    requestAnimationFrame(() => {
      dialog.classList.add('animate-dialog-open');
    });
  };

  // Open dialog when the open button is clicked
  openBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openQuiz();
    });
  });

  // Close dialog when the close button is clicked
  closeBtn.addEventListener('click', () => {
    dialog.close();
    if (quiz) {
      quiz.reset();
    }
  });

  // Close dialog when clicking outside of it
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
      if (quiz) {
        quiz.reset();
      }
    }
  });
});
